import EbookByCategory from './EbookByCategory'
import withEbookByCategory from './withEbookByCategory'

const ConnectedEbookByCategory = withEbookByCategory(EbookByCategory)

export { ConnectedEbookByCategory as EbookByCategory }
